module.exports = __webpack_public_path__ + "img/logo-mobile.bc12d20.svg";